<div class="modal-header {{klass}}-header">
    <div class="modal-title text-center py-1">
        <h4 class="mb-0">{{ header }}</h4>
        {{ subheader }}
    </div>
    <button mat-icon-button mat-dialog-close class="close si-icon-button-sm mat-black" aria-label="Close">
      <fa-icon class="si-icon" [icon]="['fal', 'xmark']"></fa-icon>
    </button>
</div>
<div class="modal-body {{klass}}-body">
    <ng-content select="[modal-body]"></ng-content>
    <h5 *ngIf="message !== ''" class="text-[16px] font-weight p-2 pt-12"> {{ message }} </h5>
</div>
<div class="modal-footer {{klass}}-footer flex justify-between">
    <ng-container *ngIf="!showLogout">
        <button matButton="outlined" type="button" (click)="onCancel()">{{ cancelButtonText }}</button>
        <button matButton="filled" type="button" [hidden]="footerButtonText === ''" (click)="buttonClicked()"
            [disabled]="footerButtonDisabled">{{ footerButtonText }}</button>
    </ng-container>

    <ng-container *ngIf="showLogout">
        <button matButton="filled" class="mat-error" type="button" (click)="logout()">Logout</button>
        <div>
            <button matButton="outlined" type="button" class="mx-1" (click)="close()">{{ cancelButtonText }}</button>
            <button matButton="filled" type="button" [hidden]="footerButtonText === ''" (click)="buttonClicked()"
                [disabled]="footerButtonDisabled">{{ footerButtonText }}</button>
        </div>
    </ng-container>

</div>
